import React from 'react';

const Categories = (props) => {
  if (props.Categories.Items.length === 0) return null;
  const heading = (
    <li className="c-categories__item c-categories__item--meta">
      <span>{props.Translations.category}:</span>
    </li>
  );
  const categories = props.Categories.Items.map((item, index) => {
    return (
      <li
        key={index}
        className="c-categories__item c-categories__item--category"
      >
        <a href={item.SearchHitUrl} aria-label={props.Translations.category}>
          {item.Name}
        </a>
      </li>
    );
  });

  return (
    <ul className="c-categories">
      {heading}
      {categories}
    </ul>
  );
};

export default Categories;
